import { z } from "zod";

export const auditFormSchema = z.object({
  email: z
    .string()
    .email("Please enter a valid email address.")
    .min(1, "Email is required."),
  apiKey: z
    .string()
    .min(1, "API Key is required.")
    .regex(
      /^[a-f0-9]{32}-us[0-9]{1,2}$/i,
      "Please enter a valid Mailchimp API key.",
    ),
});

export type AuditFormData = z.infer<typeof auditFormSchema>;
